import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { PreferenceService } from '@shared/services/cabinet/preference.service';

const BALANCE_HELP_MAPPING_WCL: Record<string, string> = {
  generale: 'WCL.020.030',
  client: 'WCL.020.040',
  fournisseur: 'WCL.020.050',
};

const BALANCE_HELP_MAPPING_EXC: Record<string, string> = {
  generale: 'W.020.030',
  client: 'W.020.040',
  fournisseur: 'W.020.050',
};

export const balanceHelpCodeResolver: ResolveFn<string | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const balanceType = route.paramMap.get('type');
  if (!balanceType) {
    return null;
  }

  if (inject(PreferenceService).isCollab) {
    return BALANCE_HELP_MAPPING_EXC[balanceType] || null;
  } else {
    return BALANCE_HELP_MAPPING_WCL[balanceType] || null;
  }
};
